import * as React from "react";
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  Button
} from "@material-ui/core";

const script = require("scriptjs");

script("https://platform.twitter.com/widgets.js", "twitter-embed");

interface Props {
  /**
   * Tweet id that needs to be shown
   */
  text?: string;
  tweetId: string;
  /**
   * Additional options to pass to twitter widget plugin
   */
  options?: { width: number };
}
export default class TwitterTweetEmbed extends React.Component<Props> {
  state = { deleted: false };
  componentDidMount() {
    this.fetchTweet(this.props.tweetId, this.props.options);
  }
  componentWillReceiveProps(next: Props) {
    if (this.props.tweetId !== next.tweetId) {
      this.fetchTweet(next.tweetId, next.options);
    }
  }
  fetchTweet = (tweetId, options) => {
    this.setState({ deleted: false });

    script.ready("twitter-embed", () => {
      const parent = this.refs.embedContainer as any;
      while (parent.firstChild) {
        parent.firstChild.remove();
      }
      if (!(window as any).twttr) {
        console.error("Failure to load window.twttr, aborting load.");
        return;
      }

      (window as any).twttr.widgets
        .createTweet(tweetId, this.refs.embedContainer, {
          ...options,
          width: Math.min(window.innerWidth - 84, 500)
        })
        .then(el => {
          //console.log("Tweet added.", el);
          this.setState({ deleted: !el });
        })
        .catch(function(el) {
          console.log("Tweet deleted.");
        });
    });
  };
  render() {
    return (
      <div>
        {this.props.text}
        <div ref="embedContainer" />
        {this.state.deleted && (
          <Card style={{ marginTop: 24, maxWidth: 340 }}>
            <CardContent>
              <Typography>
                This tweet is deleted {this.props.tweetId}
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                color="primary"
                onClick={() =>
                  window.open(
                    "https://twitter.com/i/web/status/" + this.props.tweetId
                  )
                }
              >
                Link
              </Button>
            </CardActions>
          </Card>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TwitterEmbed.tsx